import { render, staticRenderFns } from "./banner_edit.vue?vue&type=template&id=9d18a07c&scoped=true"
import script from "./banner_edit.vue?vue&type=script&lang=js"
export * from "./banner_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d18a07c",
  null
  
)

export default component.exports